import React, { useState } from 'react'

import { getRelativeAssetBasePath } from '../../../global/environments/path.js'

import ErrorBoundary from '../../FundDetails/Modules/Performance/ErrorBoundary.jsx'

import {
  getExchangeTradedFundsData2,
  getEtfClassMetadata,
} from '../Data/InvestmentProductsDataSource.js'

import PageHeader from '../../PageHeader/PageHeader.jsx'

import MutualFunds from '../MutualFunds/MutualFunds.jsx'

import ExchangeTradedFundsPerformanceOptions from './ExchangeTradedFundsPerformanceOptions.jsx'
import MorningstarOptions from '../MorningstarOptions.jsx'

import './index.css'

export default function ExchangeTradedFunds() {
  const [selectedSection, setSelectedSection] = useState()

  const onChangeSection = (section) => {
    setSelectedSection(section)
  }

  const parseData = (funds) => {
    let dislcosureList = [
      {
        fundName: 'Columbia Seligman Semiconductor and Technology ETF',
        cusip: '19761L870',
        discRef: 1,
      },
    ]

    funds.forEach((fund) => {
      dislcosureList.forEach((item) => {
        if (fund.cusip === item.cusip) {
          fund.disclosureRef = item.discRef
        }
      })
    })
  }

  return (
    <div className="etf-scope investment-products u-adel-reset">
      <PageHeader
        title="Exchange Traded Funds"
        subscribeButton={[
          {
            dataCategory: 'ETFs',
            unclickedText:
              'Subscribe for the latest ETF market news and insights',
            clickedText: 'Subscribed',
            productSubscribe: true,
          },
        ]}
      />
      <div className="u-sizeConstrained Content Expandable">
        <>
          <h2>Target Portfolio Outcomes, Not Market Benchmarks</h2>
          <p className="u-marginBottom3gu">
            All ETFs are designed to offer cost-effective, tax-efficient
            solutions. The challenge is finding ones that capitalize on active
            insights to help you outperform the benchmark. Our diverse suite of
            ETFs are constructed by active portfolio managers and fueled by
            research, so you won&apos;t find &ldquo;the kitchen sink&rdquo; in
            our portfolios &mdash; you&apos;ll find intentionally chosen
            exposures built to target the best possible outcomes.
          </p>
          <a
            href="#funds"
            className="Link u-inlineBlock u-marginBottom6gu"
            data-analytics="etf-view-all"
          >
            View all ETFs
          </a>
          <div
            id="benchmark-graphic"
            className="Card Content u-sizeConstrained u-padding0 u-marginBottom4gu"
          >
            <div className="Grid Grid--withGutter Content u-border u-border u-borderLeft0 u-borderRight0 u-borderColorPrimary">
              <div className="u-sm-sizeFull u-padding5gu u-size6of12 u-bgColorBrand u-textColorWhite">
                <h3 className="u-marginBottom4gu u-textColorWhite u-textSizeMsrp3">
                  What&apos;s <em>really</em> behind traditional benchmarks?
                </h3>
                <p className="u-textColorWhite u-textSizeMsrp1">
                  <strong>
                    Common benchmarks weren&apos;t designed to target specific
                    goals &mdash;{' '}
                  </strong>
                  they were built to show us how markets are performing. So,
                  relying on a broad benchmark may leave investors underexposed
                  to opportunities or overexposed to risk.
                </p>
              </div>
              <div className="u-sm-sizeFull u-padding4gu u-size6of12 u-bgColorLight">
                <h3 className="u-marginBottom4gu u-textSizeMsrp3">
                  Follow the opportunity &mdash; not the crowd.
                </h3>
                <div className="Grid Grid--withGutter">
                  <div className="u-sm-sizeFull u-size7of12">
                    <p className="u-textSizeMsrp1">
                      <strong>
                        Rely on an approach designed to compensate for the flaws
                        in traditional benchmarks.{' '}
                      </strong>
                      Our suite of indexed and active solutions are driven by
                      research and active insights to help you target the
                      outcomes your clients expect.
                    </p>
                  </div>
                  <div className="u-sm-sizeFull u-size5of12">
                    <img
                      src={
                        getRelativeAssetBasePath() +
                        '/content/gallery/cti-advisor/products/exchange-traded-funds/etf-box-icon.png'
                      }
                      alt="Track the opportunity - not the index"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      </div>
      <hr className="Rule Rule--thin u-textColorLightest" />
      <div id="funds" className="u-bgColorLight">
        <ErrorBoundary
          title="Exchange Traded Funds"
          message="Exchange Traded Fund information is currently unavailable due to a technical issue. Please try again later."
          isConstrained={true}
        >
          <MutualFunds
            getData={getExchangeTradedFundsData2}
            getMetadata={getEtfClassMetadata}
            // getDownload={getDownloadEtfs}
            rootNode="etfs"
            aspects={[
              {
                name: '#performance',
                info: {
                  colSpan1: 3,
                  columns: [
                    {
                      hide: true,
                    },
                    {},
                    {
                      ariaLabel: `ETF Name: activate to sort column descending`,
                      content: <>ETF Name</>,
                    },
                  ],
                },
              },
              {
                name: '#prices-yields',
                info: {
                  colSpan1: 2,
                  columns: [
                    {
                      hide: true,
                    },
                    {},
                    {
                      ariaLabel: `ETF Name: activate to sort column descending`,
                      content: <>ETF Name</>,
                    },
                    {},
                    {
                      ariaLabel: 'Market Price Amount: activate to sort column',
                      content: (
                        <>
                          Market
                          <br />
                          Price $
                        </>
                      ),
                    },
                    {
                      ariaLabel:
                        'Premium/Discount Change Amount: activate to sort column',
                      content: (
                        <>
                          Premium/Discount
                          <br />
                          chg ($)
                        </>
                      ),
                    },
                    {
                      ariaLabel:
                        'Premium/Discount Change Percentage: activate to sort column',
                      content: (
                        <>
                          Premium/Discount
                          <br />
                          chg (%)
                        </>
                      ),
                    },
                  ],
                },
              },
              {
                name: '#morningstar-ratings',
                info: {
                  colSpan1: 2,
                  columns: [
                    {
                      hide: true,
                    },
                    {},
                    {
                      ariaLabel: `ETF Name: activate to sort column descending`,
                      content: <>ETF Name</>,
                    },
                  ],
                },
              },
            ]}
            searchPlaceholder="Find an ETF"
            strategyPlaceholder="Strategy"
            ignoreClass={true}
            classOptions={
              selectedSection === '#morningstar-ratings'
                ? () => <div></div>
                : null
            }
            performanceOptions={ExchangeTradedFundsPerformanceOptions}
            morningstarOptions={MorningstarOptions}
            onChangeSection={onChangeSection}
            parseData={parseData}
          />
        </ErrorBoundary>
      </div>
      <div id="ampf-trace-loaded-page"></div>
    </div>
  )
}
